import './App.css'
import './button.css'
import React from 'react'
import { HashRouter as Router, Route} from 'react-router-dom'
import Header from './Header/Header'

import About from './About/About'

import Contact from './Contact/Contact'
import Work from './Work/Work'
import Photography from './Photography/Photography'
import Home from './Home/Home'

const App = () => (
	<Router>
		<div className="App">
			<Header />
			<Route exact path="/" component={About} />
			<Route exact path="/work" component={Work} />
			<Route exact path="/contact" component={Contact} />
			{/* <Route path="/photography" component={Photography} /> */}
		</div>
	</Router>
)

export default App



// WEBPACK FOOTER //
// ./src/components/App.js